import { CryptoEngine } from "../../crypto-engine";
import { IndexedDBService } from "../../indexed-db-service";
import { RateLimitService } from "../../rate-limit-service";
import { StorageResponse } from "../crypto/crypto-types";

export interface IHandlerContext {
  cryptoEngine: CryptoEngine;
  dbService: IndexedDBService;
  rateLimitService: RateLimitService;
  sendResponse: (target: Window, data: any, origin: string, requestId?: string) => void;
  sendError: (target: Window, message: string, code: string, origin: string, requestId?: string) => void;
}

export class HandlerContext implements IHandlerContext {
  constructor(
    public cryptoEngine: CryptoEngine,
    public dbService: IndexedDBService,
    public rateLimitService: RateLimitService,
    public sendResponse: (target: Window, data: any, origin: string, requestId?: string) => void,
    public sendError: (target: Window, message: string, code: string, origin: string, requestId?: string) => void
  ) {}

  static create(
    cryptoEngine: CryptoEngine,
    dbService: IndexedDBService,
    rateLimitService: RateLimitService
  ): HandlerContext {
    const sendResponse = (target: Window, data: any, origin: string, requestId?: string): void => {
      const response: StorageResponse<any> = {
        type: 'RESPONSE',
        data,
        requestId
      };
      target.postMessage(response, origin);
    };

    const sendError = (target: Window, message: string, code: string, origin: string, requestId?: string): void => {
      const response: StorageResponse<any> = {
        type: 'ERROR',
        error: message,
        code,
        requestId
      };
      target.postMessage(response, origin);
    };

    return new HandlerContext(
      cryptoEngine,
      dbService,
      rateLimitService,
      sendResponse,
      sendError
    );
  }
}
